"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.shape({
      hour: _propTypes.default.string,
      day: _propTypes.default.string,
      economy: _propTypes.default.string,
      premium: _propTypes.default.string,
      business: _propTypes.default.string,
      first: _propTypes.default.string,
      layover: _propTypes.default.string,
      protectionByStr: _propTypes.default.string,
      return: _propTypes.default.string,
      selfTransfer: _propTypes.default.string,
      via: _propTypes.default.string
    }),
    segment: _propTypes.default.shape({
      carrier: _propTypes.default.shape({
        name: _propTypes.default.string,
        type: _propTypes.default.string,
        code: _propTypes.default.string,
        flightNumber: _propTypes.default.number,
        image: _propTypes.default.string,
        cabinClass: _propTypes.default.string,
        carbonEmissionInKiloGrams: _propTypes.default.number
      }),
      designator: _propTypes.default.shape({
        departureStation: _propTypes.default.string,
        arrivalStation: _propTypes.default.string,
        arrivalAirport: _propTypes.default.string,
        departureAirport: _propTypes.default.string,
        departureTime: _propTypes.default.string,
        arrivalTime: _propTypes.default.string
      }),
      duration: _propTypes.default.number,
      layoverTime: _propTypes.default.number
    }),
    isProtected: _propTypes.default.bool,
    isSelfTransfer: _propTypes.default.bool,
    isStopover: _propTypes.default.bool,
    isLast: _propTypes.default.bool,
    protectedBy: _propTypes.default.string,
    protectedByAction: _propTypes.default.func,
    selfTransferAction: _propTypes.default.func,
    isTechnicalStop: _propTypes.default.bool,
    technicalStopLabel: _propTypes.default.string,
    locale: _propTypes.default.string,
    hourCycle: _propTypes.default.number,
    isMobile: _propTypes.default.bool,
    useLocalTimezone: _propTypes.default.bool,
    unifiedConfirmationPageProp: _propTypes.default.bool,
    guest: _propTypes.default.number,
    technicalStopStation: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    segment: {},
    isProtected: false,
    isSelfTransfer: false,
    isStopover: false,
    isLast: false,
    protectedBy: null,
    protectedByAction: null,
    selfTransferAction: null,
    // eslint-disable-next-line no-script-url
    linkVoid: 'javascript:void(0)',
    isTechnicalStop: false,
    technicalStopLabel: null,
    locale: 'en-gb',
    hourCycle: 12,
    isMobile: false,
    useLocalTimezone: false,
    unifiedConfirmationPageProp: false,
    technicalStopStation: null
  }
};
exports.default = _default;